import { render, staticRenderFns } from "./CandidateProfileFormAddInput.vue?vue&type=template&id=1dfc7c28&scoped=true&"
import script from "./CandidateProfileFormAddInput.vue?vue&type=script&lang=js&"
export * from "./CandidateProfileFormAddInput.vue?vue&type=script&lang=js&"
import style0 from "./CandidateProfileFormAddInput.vue?vue&type=style&index=0&id=1dfc7c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfc7c28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
